import MergeClasses from './MergeClasses';
export default MergeClasses;
